import {Theme, createStyles} from '@material-ui/core';
import {StyleRules} from '@material-ui/core/styles';

const specialVacationStyles = (_: Theme): StyleRules =>
	createStyles({
		primaryButton: {
			backgroundColor: '#131a2e',
			color: 'white',
			'&:hover': {
				backgroundColor: '#07070e',
				color: 'white',
			},
		},
		secondaryButton: {
			backgroundColor: '#375184',
			color: 'white',
			'&:hover': {
				backgroundColor: '#12122b',
				color: 'white',
			},
		},
		vacationDays: {
			margin: '24px 0',
		},
	});

export default specialVacationStyles;
